class TownlandsProductTabs extends HTMLElement {
  #abortController;
  #tabs = [];
  #panels = [];

  connectedCallback() {
    if (this.dataset.tabsReady === 'true') return;

    this.#tabs = [...this.querySelectorAll('[role="tab"]')];
    this.#panels = this.#tabs.map((tab) => {
      const panelId = tab.getAttribute('aria-controls');
      return panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;
    });

    if (
      this.#tabs.length !== 2 ||
      this.#panels.some((panel) => !(panel instanceof HTMLElement))
    ) {
      return;
    }

    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.#tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.#activate(index), { signal });
      tab.addEventListener('keydown', (event) => this.#onKeydown(event, index), {
        signal,
      });
    });

    this.dataset.tabsReady = 'true';
    this.#activate(0);
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = undefined;
    delete this.dataset.tabsReady;
  }

  #activate(activeIndex, moveFocus = false) {
    this.#tabs.forEach((tab, index) => {
      const isActive = index === activeIndex;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      if (moveFocus && isActive) tab.focus();
    });

    this.#panels.forEach((panel, index) => {
      panel.hidden = index !== activeIndex;
    });
  }

  #onKeydown(event, currentIndex) {
    let nextIndex;

    switch (event.key) {
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.#tabs.length) % this.#tabs.length;
        break;
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.#tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.#tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.#activate(nextIndex, true);
  }
}

if (!customElements.get('townlands-product-tabs')) {
  customElements.define('townlands-product-tabs', TownlandsProductTabs);
}
